import type { MailboxInfo } from "owa-client-types";
import { action } from "satcheljs";
import type { CancelDelaySendSource } from "../store/schema/CancelDelaySendSource";

export interface CancelDelaySendActionMessage {
    itemId: string | undefined;
    mailboxInfo: MailboxInfo;
    eventTimestamp?: number;
    source?: CancelDelaySendSource;
}

export const cancelDelaySend: (itemId: string | undefined, mailboxInfo: MailboxInfo, eventTimestamp?: number, source?: CancelDelaySendSource) => CancelDelaySendActionMessage = action("cancelDelaySend", (itemId: string | undefined, mailboxInfo: MailboxInfo, eventTimestamp?: number, source?: CancelDelaySendSource): CancelDelaySendActionMessage => ({
    itemId,
    mailboxInfo,
    eventTimestamp,
    source,
}));

export const afterCancelDelaySend: (itemId: string | undefined, mailboxInfo: MailboxInfo, eventTimestamp?: number, source?: CancelDelaySendSource) => CancelDelaySendActionMessage = action("afterCancelDelaySend", (itemId: string | undefined, mailboxInfo: MailboxInfo, eventTimestamp?: number, source?: CancelDelaySendSource): CancelDelaySendActionMessage => ({
    itemId,
    mailboxInfo,
    eventTimestamp,
    source,
}));

export default cancelDelaySend;
